import React from 'react';
import PropTypes from 'prop-types';
import { useField, useFormikContext } from 'formik';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactTooltip from 'react-tooltip';

const FormikInput = ({
  label = '',
  className = '',
  onChange = null,
  required = false,
  tooltip = '',
  col = 12,
  ...props
}) => {
  const [field, meta] = useField(props);
  const { setFieldValue } = useFormikContext();

  return (
    <div className={`col-md-${col} col-sm-12`} style={{ display: 'flex' }}>
      <div
        className={`input-type-style`}
        style={{ ...props.style, display: 'flex' }}
      >
        <div style={{ width: '100%' }}>
          <input
            {...field}
            {...props}
            className={meta.error ? 'input-error' : 'input-style'}
            onChange={(event) => {
              setFieldValue(field.name, event.target.value);
              if (onChange) {
                onChange(event.target.value);
              }
            }}
          />
          <ReactTooltip className="input-tooltip" multiline place="right" />
          <label
            htmlFor={field.name}
            className={`
            input-label-style
            ${meta.error ? 'red' : 'dim'}
            ${required ? 'input-required' : ''}
          `}
          >
            {label}
            {tooltip && (
              <span className="ml-1" data-tip={tooltip}>
                <FontAwesomeIcon icon="question-circle" />
              </span>
            )}
          </label>
        </div>
        {meta.error && <span className="input-helper red">{meta.error}</span>}
      </div>
    </div>
  );
};

FormikInput.propTypes = {
  onChange: PropTypes.func,
  label: PropTypes.string,
  className: PropTypes.string,
  tooltip: PropTypes.string,
  required: PropTypes.bool,
};

FormikInput.defaultProps = {
  onChange: null,
  label: '',
  className: '',
  tooltip: '',
  required: false,
};

export default FormikInput;
